import React, { useEffect, useRef, useState } from "react";

/**
 * Free-text input with autocomplete suggestions from a static array.
 */
export default function Autocomplete({
  label,
  value,
  onChange,
  options = [],
  placeholder,
  testId,
  required = false,
}) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    const onClickOutside = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  const q = (value || "").toLowerCase();
  const filtered = q
    ? options.filter((o) => o.toLowerCase().includes(q) && o.toLowerCase() !== q).slice(0, 8)
    : options.slice(0, 8);

  return (
    <div ref={wrapRef} className="relative">
      {label && (
        <label className="block text-sm font-medium mb-2">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <input
        type="text"
        value={value || ""}
        onChange={(e) => {
          onChange(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
        placeholder={placeholder}
        className="neu-input"
        data-testid={testId}
        autoComplete="off"
      />
      {open && filtered.length > 0 && (
        <div
          className="absolute z-30 mt-2 left-0 right-0 max-h-56 overflow-y-auto rounded-xl bg-white shadow-neu border border-neu-muted/20"
          data-testid={`${testId}-suggestions`}
        >
          {filtered.map((o) => (
            <button
              key={o}
              type="button"
              onClick={() => {
                onChange(o);
                setOpen(false);
              }}
              className="w-full text-left px-3 py-2 hover:bg-neu-bg text-sm transition-colors"
            >
              {o}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
